import React, { Component } from 'react';
import PropTypes from 'prop-types';
import OptimizeImagesService from 'services/OptimizeImages.service';

import styles from './ImageGreyBackground.module.scss';

import { Container } from 'common/components/Layout/Layout';

class ImageGreyBackground extends Component {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    source: PropTypes.string.isRequired,
    alternative: PropTypes.string.isRequired
  };

  static defaultProps = {
    className: ''
  };

  render() {
    const { className, children, source, alternative } = this.props;

    return (
      <Container className={styles.GroupDescriptionContainer}>
        <div
          className={`
          ${styles.TextWrapper} 
          ${className}
        `}
        >
          <span className={styles.GreyBackground} />
          {children}
        </div>
        <img
          className={styles.IntroImage}
          src={OptimizeImagesService.adjustImageSize(source)}
          alt={alternative}
        />
      </Container>
    );
  }
}

export default ImageGreyBackground;



// WEBPACK FOOTER //
// ./src/common/components/ImageGreyBackground/ImageGreyBackground.js